import ConTipoPolizaComponent from '@/components/conta/tipo_poliza/ConTipoPolizaComponent'
import ConCuentasContablesComponent from '@/components/conta/cuentas_contables/ConCuentasContablesComponent'
import ConPolizasContablesComponent from '@/components/conta/polizas_contables/ConPolizasContablesComponent'
import ConPolizasContablesFormComponent from '@/components/conta/polizas_contables/ConPolizasContablesFormComponent'
import EstadoResultadoRptComponent from '@/components/conta/reportes/EstadoResultadoRptComponent'
import MayorRptComponent from '@/components/conta/reportes/MayorRptComponent'
import DiarioRptComponent from '@/components/conta/reportes/DiarioRptComponent'
import BalanceGeneralRptComponent from '@/components/conta/reportes/BalanceGeneralRptComponent'
import TrasladoPolizasContablesComponent from '@/components/conta/traslados_polizas/TrasladoPolizasContablesComponent'


export default [
    {
        path: '/con/tipo-poliza/',
        name: 'con-tipo-poliza',
        component: ConTipoPolizaComponent,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/con/cuentas-contables/',
        name: 'con-cuentas-contables',
        component: ConCuentasContablesComponent,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/con/polizas-contables/',
        name: 'con-polizas-contables',
        component: ConPolizasContablesComponent,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/con/polizas-contables/editar/:id/',
        name: 'con-polizas-contables-editar',
        component: ConPolizasContablesFormComponent,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/con/polizas-contables/nuevo/',
        name: 'con-polizas-contables-nuevo',
        component: ConPolizasContablesFormComponent,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/conta/reportes/estados-resultados/',
        name: 'conta-estado-resultado',
        component: EstadoResultadoRptComponent,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/conta/reportes/mayor-contable/',
        name: 'conta-mayor-contable',
        component: MayorRptComponent,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/conta/reportes/diario-contable/',
        name: 'conta-diario-contable',
        component: DiarioRptComponent,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'conta-rpt-balance-general',
        path: '/conta/reportes/balance-general/',
        component: BalanceGeneralRptComponent,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'conta-traslados-polizas',
        path: '/conta/traslados/',
        component: TrasladoPolizasContablesComponent,
        meta: {
            requiresAuth: true
        }
    }
]
